export default __webpack_public_path__ + "static/media/imdb.301ae982.png";